import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoService } from '@jsverse/transloco';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-admin-tabs',
  template: `
    <app-tabs [links]="links"></app-tabs>
  `,
  imports: [SharedModule],
  standalone: true,
})
export class AdminTabsComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  private translocoService = inject(TranslocoService);

  links: { label: string; routerLink: string; icon: string }[] = [];

  ngOnInit(): void {
    this.translocoService
      .selectTranslation()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.links = [
          {
            label: this.translocoService.translate('settings.admin-tabs.admin-data'),
            routerLink: '/administration/donnees',
            icon: 'file-pen',
          },
          {
            label: this.translocoService.translate('settings.admin-tabs.online-payment'),
            routerLink: '/administration/paiement-en-ligne',
            icon: 'credit-card',
          },
        ];
      });
  }
}
